import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_modal_header_notification = _resolveComponent("modal-header-notification")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_Field = _resolveComponent("Field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_FocusLock = _resolveComponent("FocusLock")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, null, {
    default: _withCtx(({ invalid }) => [
      _createVNode(_component_v_dialog, {
        modelValue: _ctx.visible,
        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.visible) = $event)),
        width: "500"
      }, {
        activator: _withCtx(({}) => [
          _createVNode(_component_v_btn, {
            class: "px-3 mr-2",
            color: "primary",
            onClick: _ctx.open
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('einstellungen.benutzerliste.button')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_FocusLock, null, {
            default: _withCtx(() => [
              _createElementVNode("form", {
                id: "focusLockDialogForm",
                onSubmit: _cache[15] || (_cache[15] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
              }, [
                _createVNode(_component_v_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, { class: "headline font-weight-bold mb-2" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('praxisgruppe.einstellungen.adduserdialog.title')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_modal_header_notification),
                    _createVNode(_component_v_card_text, { class: "pb-0 pt-0" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Field, {
                          modelValue: _ctx.benutzer.email,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.benutzer.email) = $event)),
                          name: "Email",
                          rules: _ctx.getValidation('benutzerCreateApiDto.email')
                        }, {
                          default: _withCtx(({ errors, field }) => [
                            _createVNode(_component_v_text_field, _mergeProps(field, {
                              modelValue: _ctx.benutzer.email,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.benutzer.email) = $event)),
                              autofocus: "",
                              label: _ctx.$t('einstellungen.addaccount.email') + '*',
                              placeholder: "example@test.com",
                              "error-messages": errors
                            }), null, 16, ["modelValue", "label", "error-messages"])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "rules"]),
                        _createVNode(_component_Field, {
                          modelValue: _ctx.benutzer.passwort,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.benutzer.passwort) = $event)),
                          name: "Passwort",
                          rules: _ctx.getValidation('benutzerCreateApiDto.passwort') + '|valid_password_format'
                        }, {
                          default: _withCtx(({ errors, field }) => [
                            _createVNode(_component_v_text_field, _mergeProps(field, {
                              modelValue: _ctx.benutzer.passwort,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.benutzer.passwort) = $event)),
                              label: _ctx.$t('einstellungen.addaccount.password') + '*',
                              type: "password",
                              "error-messages": errors
                            }), null, 16, ["modelValue", "label", "error-messages"])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "rules"]),
                        _createVNode(_component_Field, {
                          modelValue: _ctx.benutzer.vorname,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.benutzer.vorname) = $event)),
                          name: "Vorname",
                          rules: _ctx.getValidation('benutzerCreateApiDto.vorname')
                        }, {
                          default: _withCtx(({ errors, field }) => [
                            _createVNode(_component_v_text_field, _mergeProps(field, {
                              modelValue: _ctx.benutzer.vorname,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.benutzer.vorname) = $event)),
                              label: _ctx.$t('einstellungen.addaccount.vorname') + '*',
                              placeholder: "...",
                              "error-messages": errors
                            }), null, 16, ["modelValue", "label", "error-messages"])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "rules"]),
                        _createVNode(_component_Field, {
                          modelValue: _ctx.benutzer.nachname,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.benutzer.nachname) = $event)),
                          name: "Nachname",
                          rules: _ctx.getValidation('benutzerCreateApiDto.nachname')
                        }, {
                          default: _withCtx(({ errors, field }) => [
                            _createVNode(_component_v_text_field, _mergeProps(field, {
                              modelValue: _ctx.benutzer.nachname,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.benutzer.nachname) = $event)),
                              label: _ctx.$t('einstellungen.addaccount.nachname') + '*',
                              placeholder: "...",
                              "error-messages": errors
                            }), null, 16, ["modelValue", "label", "error-messages"])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "rules"]),
                        _createVNode(_component_Field, {
                          modelValue: _ctx.benutzer.rolle,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.benutzer.rolle) = $event)),
                          name: "Rolle",
                          rules: "required"
                        }, {
                          default: _withCtx(({ errors, field }) => [
                            _createVNode(_component_v_select, _mergeProps(field, {
                              modelValue: _ctx.benutzer.rolle,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.benutzer.rolle) = $event)),
                              "item-props": _ctx.itemProps,
                              items: _ctx.praxisgruppeBenutzerRollen,
                              label: _ctx.$t('einstellungen.addaccount.rolle') + '*',
                              "error-messages": errors,
                              "menu-props": { attach: '#focusLockDialogForm' }
                            }), null, 16, ["modelValue", "item-props", "items", "label", "error-messages"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_Field, {
                          modelValue: _ctx.benutzer.mobilNummer,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.benutzer.mobilNummer) = $event)),
                          name: "MobilNummer",
                          rules: _ctx.getValidation('benutzerCreateApiDto.mobilNummer') + '|valid_swiss_telephone_number'
                        }, {
                          default: _withCtx(({ errors, field }) => [
                            _createVNode(_component_v_text_field, _mergeProps(field, {
                              modelValue: _ctx.benutzer.mobilNummer,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.benutzer.mobilNummer) = $event)),
                              label: _ctx.$t('einstellungen.addaccount.mobilnummer') + '*',
                              placeholder: "+41 77 111 22 33",
                              "error-messages": errors
                            }), null, 16, ["modelValue", "label", "error-messages"])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "rules"]),
                        _createVNode(_component_Field, {
                          modelValue: _ctx.benutzer.sprache,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.benutzer.sprache) = $event)),
                          name: "Sprache",
                          rules: 'required'
                        }, {
                          default: _withCtx(({ errors, field }) => [
                            _createVNode(_component_v_select, _mergeProps(field, {
                              modelValue: _ctx.benutzer.sprache,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.benutzer.sprache) = $event)),
                              items: _ctx.sprachen,
                              label: _ctx.$t('einstellungen.addaccount.sprache') + '*',
                              "error-messages": errors,
                              "menu-props": { attach: '#focusLockDialogForm' }
                            }), null, 16, ["modelValue", "items", "label", "error-messages"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_actions, { class: "ml-4" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          color: "primary",
                          disabled: invalid || _ctx.requiredFieldsFilled,
                          variant: "flat",
                          type: "submit",
                          class: "modalbutton mb-3"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('components.dialog.save')), 1)
                          ]),
                          _: 2
                        }, 1032, ["disabled"]),
                        _createVNode(_component_v_btn, {
                          class: "modalbutton mb-3",
                          variant: "flat",
                          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.visible = false))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('components.dialog.cancel')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ], 32)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1032, ["modelValue"])
    ]),
    _: 1
  }))
}